import script from "./Alarms.vue?vue&type=script&lang=ts&setup=true"
export * from "./Alarms.vue?vue&type=script&lang=ts&setup=true"

import "./Alarms.vue?vue&type=style&index=0&id=2b42c572&lang=scss"

const __exports__ = script;

export default __exports__